import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Input, Btn, Spinner } from '../components/common/UI';
import toast from 'react-hot-toast';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/');
    } catch (err) {
      toast.error((err.response && err.response.data && err.response.data.error) || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' }}>
      <div style={{ width: 380, background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 32 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>💬</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: '#f1f5f9' }}>WhatsApp Admin</h1>
          <p style={{ color: '#64748b', fontSize: 13, marginTop: 4 }}>Sign in to your dashboard</p>
        </div>
        <form onSubmit={handle}>
          <Input
            label="Email"
            type="email"
            placeholder="admin@example.com"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
          <Input
            label="Password"
            type="password"
            placeholder="••••••••"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />
          <Btn type="submit" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
            {loading ? <Spinner size={16} /> : 'Sign In'}
          </Btn>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, color: '#64748b', fontSize: 13 }}>
          No account?{' '}
          <Link to="/register" style={{ color: '#25d366' }}>Register first admin</Link>
        </p>
      </div>
    </div>
  );
}
